module.exports = __webpack_public_path__ + "img/ftb.7d7581fb.png";